// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4332":"de817e8d95935c9c","5525":"e2a4a1336ce76387"}[chunkId] + ".js";
};